import { ChangeDetectorRef, Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SesionService } from 'src/app/core/service/sesion.service';
import {
  FileDto,
  FileSave,
  UploadScreenInfo,
} from 'src/app/shared/components/atoms/file-upload-component/model/file-uplaod.interface';
import { InfoAfip, TaxValidation, TypePerson } from '../tax-validation/model/tax-validation';
import { PotentialCustomer } from '../potential-customer/model/potential-customer';
import { Constants, CreateFile, DocKey, DocumentId } from 'src/app/core/model/constans';
import { SelectOption } from 'src/app/shared/components/atoms/model/option.interface';
import { FileUploadService } from './service/file-upload.service';
import { ShadowScrollService } from 'src/app/core/service/utils/shadow-scroll.service';
import { Utils } from 'src/app/core/service/utils/regex-list.regex';
import { filter, forkJoin, from, Observable, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { FilePresignUrlUploadService } from 'src/app/shared/components/atoms/file-upload-component/service/file-upload-component.service';
import { environment } from 'src/environments/environment';
import { BioDocumentCaptureResult } from './model/bio-document.model';
import { BIO_CUSTOMER_BIOMETRIC_SESSION_KEY, BioCustomerBiometricSession, BioProcessInitResponse } from './model/bio-process.model';
import { BioDocumentFlowComponent } from './bio-document/bio-document-flow.component';
import { BioFaceFlowComponent, BioFaceCaptureResult } from './bio-face/bio-face-flow.component';
import { BioDocumentValidationService, BioDocumentValidationResult } from './service/bio-document-validation.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit {
  @Output()
  onComplete = new EventEmitter<number>();

  @Output()
  onBack = new EventEmitter();

  @ViewChild(BioDocumentFlowComponent)
  bioDocumentFlow?: BioDocumentFlowComponent;

  @ViewChild(BioFaceFlowComponent)
  bioFaceFlow?: BioFaceFlowComponent;

  condition: string[] = ['Exento', 'Convenio Multilateral'];
  files: any[] = [];
  documentForm: FormGroup;
  form: FormGroup;
  submitted: boolean;
  cantDniAdd: number = 0;
  loading: boolean;
  cantFiles = 0;
  fileSesion: UploadScreenInfo = {
    fileDoc: [],
    dniValidationRequired: false,
  };
  optionMultilateral: number | undefined;
  options: SelectOption[] = [
    { value: 1, text: 'CM05 y acuse de recibo de año anterior' },
    { value: 2, text: 'Constancia de sistema de padrón web < 30 días' },
  ];
  isSHL: boolean = false;
  REBA: boolean | undefined;
  infoAfip: InfoAfip | undefined;
  potentialCustomer: PotentialCustomer | null;
  infoTax: TaxValidation | null;
  validateCount: number;
  noCuit: boolean | undefined = false;
  filesUpload: FileDto[] = [];
  ocrError: boolean = false;
  dniValidationRequired: boolean;
  private bucketSubscription: Subscription | undefined;

  bioEnabled: boolean = !!environment.features?.enableBioDocumentValidation;
  bioApplicable: boolean = false;
  bioIdentityCompleted: boolean = false;
  bioFaceStageActive: boolean = false;
  bioUploading: boolean = false;
  bioValidationState: 'idle' | 'uploaded' | 'validating' | 'succeeded' | 'failed' = 'idle';
  /** Respuesta LIVEPROBE compartida por el DNI y la selfie; evita otro init-process. */
  bioInitResponse?: BioProcessInitResponse;

  constructor(
    private fb: FormBuilder,
    private sesion: SesionService,
    private service: FileUploadService,
    private readonly bucketService: FilePresignUrlUploadService,
    private readonly bioValidationService: BioDocumentValidationService,
    public shadowScroll: ShadowScrollService,
    private cd: ChangeDetectorRef,
  ) {
    this.potentialCustomer = this.sesion.getItem('potential_customer');
    this.infoTax = this.sesion.getItem('tax_validation');
    this.service.getUploadFile().subscribe((data) => {
      this.fileSesion = data;
    });
    this.REBA = this.infoTax?.REBA;
    this.infoAfip = this.infoTax?.infoAfip;
    this.noCuit = this.infoTax?.noCuit;
    this.cantDniAdd = this.fileSesion?.cantAddDniSh ? this.fileSesion?.cantAddDniSh : 0;
    this.submitted = false;
    this.validateCount = 0;
    this.loading = false;
    this.dniValidationRequired = false;
    this.bioApplicable =
      this.bioEnabled &&
      !this.infoTax?.infoAfip?.SH &&
      (this.infoAfip?.typePerson === TypePerson.FISICA ||
        this.infoAfip?.typePerson === TypePerson.JURIDICA ||
        (this.noCuit === true && this.infoTax?.infoCuil?.typePerson === TypePerson.FISICA));
    this.setFiles();
    this.documentForm = this.fb.group({});
    this.form = this.fb.group({
      option: [this.fileSesion?.optionMultilateral ? this.fileSesion.optionMultilateral : ''],
    });
  }

  ngOnInit(): void {
    if (this.bioEnabled) {
      this.sesion.setItem(BIO_CUSTOMER_BIOMETRIC_SESSION_KEY, null);
    }
    this.getFilesSesion();
    const controlKeys = Object.keys(this.documentForm.controls);
    const dniAtrasControl = this.documentForm.controls[DocKey.DNI_ATRAS];

    controlKeys.forEach((controlKey) => {
      if (controlKey !== DocKey.DNI_ATRAS) {
        // Suscribirse a los cambios solo si no es el control dni_atras
        this.documentForm.controls[controlKey].valueChanges
          .pipe(
            filter((_) => !dniAtrasControl || !dniAtrasControl.dirty),
          )
          .subscribe(() => {
            this.service.hideSpinner();
            console.log(`Se llamó a la validación para el control ${controlKey}`);
            // Aquí puedes poner el código que quieres ejecutar cuando se modifique cualquier control que no sea dni_atras
          });
      }
    });

    if (dniAtrasControl) {
      dniAtrasControl.valueChanges.subscribe((value) => {
        // El OCR legacy no participa cuando el flujo biométrico está activo.
        if (this.bioApplicable) {
          return;
        }
        console.log('se llamo validacion ocr');
        if (this.infoTax?.infoAfip?.typePerson != TypePerson.JURIDICA) {
          this.ocrValidation();
        } else {
          this.dniValidationRequired = true;
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.bucketSubscription) {
      this.bucketSubscription.unsubscribe();
    }
  }

  setFiles() {
    this.files = [];
    if (!this.noCuit && this.infoAfip?.typePerson == TypePerson.JURIDICA && !this.infoTax?.infoAfip?.SH) {
      this.createFile(
        'Frente DNI del Socio gerente / Administrador titular o Apoderado',
        'Adjunta una foto del frente del DNI',
        'file 1',
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.DNI_PRESIDENTE_FRENTE,
        true,
        DocKey.DNI_P_FRENTE,
        CreateFile.ONE_FILE,
      );
      this.createFile(
        'Dorso DNI del Socio gerente / Administrador titular o Apoderado',
        'Adjunta una foto del dorso del DNI',
        'file 2',
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.DNI_PRESIDENTE_DORSO,
        true,
        DocKey.DNI_P_ATRAS,
        CreateFile.ONE_FILE,
      );
      this.createFile(
        'Poder de apoderado (opcional)',
        'Adjunta una foto del poder de apoderado',
        'file 3',
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.PODER_APODERADO,
        false,
        DocKey.PODER_APODERADO,
        CreateFile.ONE_FILE,
      );
      this.createFile(
        'Acta de designación de autoridades vigente de la sociedad.',
        'Adjunta una foto de la acta de designación de autoridades vigente de la sociedad.',
        'file 4',
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.ACTA_DE_DESIGNACION_DE_AUTORIDADES,
        true,
        DocKey.ACTA_DE_DESIGNACION_DE_AUTORIDADES,
      );
      this.createFile(
        'Estatuto o Contrato Social.',
        'Adjunta una foto del estatuto o contrato social.',
        'file 5',
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.ESTATUTO_O_CONTRATO_SOCIAL,
        true,
        DocKey.ESTATUTO_O_CONTRATO_SOCIAL,
      );
    } else if (this.infoTax?.infoAfip?.SH) {
      this.createFile(
        'Frente de tu DNI.',
        'Adjunta una foto del frente de tu DNI ',
        'file 1',
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.DNI_INTEGRANTE,
        true,
        DocKey.DNI_FRENTE,
        CreateFile.ONE_FILE,
      );
      this.createFile(
        'Dorso de tu DNI.',
        'Adjunta una foto del dorso de tu DNI ',
        'file 2',
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        true,
        DocumentId.DNI_INTEGRANTE,
        true,
        DocKey.DNI_ATRAS,
        CreateFile.ONE_FILE,
      );
      this.createFile(
        'Frente DNI Socio 1',
        'Ajunte una foto del frente del DNI del socio 1',
        'file 1',
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.DNI_INTEGRANTE,
        true,
        DocKey.DNI_O_FRENTE + 0,
        CreateFile.ONE_FILE,
      );
      this.createFile(
        'Dorso DNI Socio 1',
        'Ajunte una foto del dorso del DNI del socio 1',
        'file 2',
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.DNI_INTEGRANTE,
        true,
        DocKey.DNI_O_ATRAS + 0,
        CreateFile.ONE_FILE,
      );
      this.createShDniAddFiles();
    } else {
      this.createFile(
        'Frente de tu DNI.',
        'Adjunta una foto del frente de tu DNI ',
        'file 1',
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.DNI_FRENTE,
        true,
        DocKey.DNI_FRENTE,
        CreateFile.ONE_FILE,
      );
      this.createFile(
        'Dorso de tu DNI.',
        'Adjunta una foto del dorso de tu DNI ',
        'file 2',
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        true,
        DocumentId.DNI_DORSO,
        true,
        DocKey.DNI_ATRAS,
        CreateFile.ONE_FILE,
      );
    }

    if (!this.infoTax?.directionSame && this.infoAfip?.ivaCondition != 'NO CATEGORIZADO') {
      let id = this.files.length + 1;
      this.createFile(
        'Servicio/Impuesto que valide el domicilio o Contrato de Locación.',
        'Adjunta una foto del servicio/impuesto',
        'file ' + id,
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.IMPUESTO_CONTRATO_LOCATION,
        true,
        DocKey.IMPUESTO_CONTRATO_LOCATION,
      );
    }

    if (this.REBA) {
      let id = this.files.length + 1;
      this.createFile(
        'Constancia Licencia para Venta de Bebidas Alcohólicas.',
        'Adjunta una foto de la constancia de la licencia',
        'file ' + id,
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.REBA,
        true,
        DocKey.REBA,
      );
    }

    if (this.infoTax?.noCuit) {
      let id = this.files.length + 1;
      this.createFile(
        'Constancia de CUIL (opcional)',
        'Adjunta una foto de la constancia de la CUIL',
        'file ' + id,
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.CONSTANCIA_CUIL,
        false,
        DocKey.CONSTANCIA_CUIL,
      );
    }

    if (this.infoTax?.IIBBCondition == Constants.EXENTO) {
      let id = this.files.length + 1;
      this.createFile(
        'Resolución de Exención de Ingresos Brutos',
        'Adjunta una foto de la resolución de exención de ingresos brutos',
        'file ' + id,
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.EXENTO_RESOLUCION,
        true,
        DocKey.EXENTO_RESOLUCION,
      );
    }
    let constaciaIsRequired: boolean = true;
    let requiredMunicipalContributionCBA: boolean = false;
    let requiredMunicipalContributionCR: boolean = false;
    let textConstanciaMunicipalContribution = '';
    if (
      this.potentialCustomer?.location.state.toUpperCase() == 'CÓRDOBA' &&
      this.infoTax?.infoAfip?.municipalContribution == 'S'
    ) {
      constaciaIsRequired = false;
      requiredMunicipalContributionCBA = true;
      textConstanciaMunicipalContribution = 'Constancia de Impuesto Municipal (opcional)';
    } else if (
      this.potentialCustomer?.location.city.toUpperCase() == 'COMODORO RIVADAVIA' &&
      (this.infoTax?.infoAfip?.municipalContribution == 'S' || this.infoTax?.infoAfip?.municipalContribution == 'E')
    ) {
      constaciaIsRequired = true;
      requiredMunicipalContributionCR = true;
      textConstanciaMunicipalContribution = 'Constancia de Impuesto Municipal';
    }

    if (requiredMunicipalContributionCBA || requiredMunicipalContributionCR) {
      let id = this.files.length + 1;
      this.createFile(
        textConstanciaMunicipalContribution,
        'Adjunta una foto de la constancia de impuesto municipal',
        'file ' + id,
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.IMPUESTO_MUNICIPAL,
        constaciaIsRequired,
        DocKey.IMPUESTO_MUNICIPAL,
      );
    }

    if (
      (this.infoTax?.attachIIBBDocument?.upload && this.infoTax?.IIBBCondition == Constants.INSCRIPTO) ||
      this.infoTax?.IIBBCondition == Constants.EXENTO ||
      (this.infoTax?.IIBBCondition == Constants.REGIMEN_SIMPLIFICADO && !this.infoTax?.infoAfip?.simplifiedMonotributo)
    ) {
      let id = this.files.length + 1;
      let isRequired: boolean = this.infoTax?.attachIIBBDocument?.required ? true : false;
      this.createFile(
        'Constancia de Inscripción Ingresos Brutos',
        'Adjunta una foto de la constancia de inscripción de ingresos brutos',
        'file ' + id,
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.CONSTANCIA_IIBB,
        isRequired,
        DocKey.CONSTANCIA_IIBB,
      );
    }

    if (this.infoTax?.IIBBCondition == Constants.CONVENIO_MULTILARETAL) {
      let id = this.files.length + 1;
      this.createFile(
        'CM05',
        'Adjunta una foto del CM05',
        'file ' + id,
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.IIBB_CM05,
        true,
        DocKey.IIBB_CM05,
      );
      id++;
      this.createFile(
        'Constancia de sistema padron web menor a 30 días',
        'Adjunta una foto de la constancia',
        'file ' + id,
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.IIBB_CONSTANCIA_PADRON,
        true,
        DocKey.IIBB_CONSTANCIA_PADRON,
      );
      id++;
      this.createFile(
        'Acuse de recibo de año anterior (opcional)',
        'Adjunta una foto del acuse de recibo de año anterior',
        'file ' + id,
        ['.png', '.jpeg', '.jpg', '.pdf'],
        20,
        true,
        false,
        DocumentId.IIBB_ACUSE_RECIBO,
        false,
        DocKey.IIBB_ACUSE_RECIBO,
      );
    }
  }

  createShDniAddFiles() {
    if (this.cantDniAdd > 0) {
      let cont = 0;
      let cantDoc = 1;
      for (var i = 0; i < this.cantDniAdd; i += +2) {
        cont++;
        cantDoc++;
        this.createFile(
          'Frente DNI Socio ' + cantDoc,
          'Ajunte una foto del frente del DNI del socio ' + cantDoc,
          'file 1',
          ['.png', '.jpeg', '.jpg', '.pdf'],
          20,
          true,
          false,
          DocumentId.DNI_INTEGRANTE,
          true,
          DocKey.DNI_O_FRENTE + Number(cont),
          CreateFile.ONE_FILE,
        );
        this.createFile(
          'Dorso DNI Socio ' + cantDoc,
          'Ajunte una foto del dorso del DNI del socio ' + cantDoc,
          'file 1',
          ['.png', '.jpeg', '.jpg', '.pdf'],
          20,
          true,
          false,
          DocumentId.DNI_INTEGRANTE,
          true,
          DocKey.DNI_O_ATRAS + Number(cont),
          CreateFile.ONE_FILE,
        );
      }
    }
  }

  createFile(
    label: string,
    subtitle: string,
    fileId: string,
    extensions: string[],
    size: number,
    isImg: boolean,
    validate: boolean,
    documentId: number,
    required: boolean,
    key: string,
    oneFile?: boolean,
  ) {
    let file = {
      label: label,
      subtitle: subtitle,
      fileId: fileId,
      file: null,
      extensions: extensions,
      size: size,
      isImg: isImg,
      ocrValidation: validate,
      documentId: documentId,
      oneFile: oneFile ? oneFile : false,
      required: required,
      key: key,
    };
    this.files.push(file);
  }

  back() {
    if (this.bioApplicable) {
      this.sesion.setItem(BIO_CUSTOMER_BIOMETRIC_SESSION_KEY, null);
    }
    this.onBack.emit();
  }

  get isIdentityStageActive(): boolean {
    return this.bioApplicable && !this.bioIdentityCompleted && !this.bioFaceStageActive;
  }

  get isBioFlowActive(): boolean {
    return this.isIdentityStageActive || this.bioFaceStageActive;
  }

  get headerTitle(): string {
    if (this.isBioFlowActive) {
      return 'Verifica tu identidad';
    }
    if (this.bioApplicable && this.usesJuridicaRepresentativeKeys()) {
      return 'Documentación de la empresa';
    }
    return 'Documentos';
  }

  private usesJuridicaRepresentativeKeys(): boolean {
    return !this.noCuit && this.infoAfip?.typePerson === TypePerson.JURIDICA && !this.infoTax?.infoAfip?.SH;
  }

  isBioManagedKey(key: string): boolean {
    if (!this.bioApplicable) {
      return false;
    }
    const frontKey = this.usesJuridicaRepresentativeKeys() ? DocKey.DNI_P_FRENTE : DocKey.DNI_FRENTE;
    const backKey = this.usesJuridicaRepresentativeKeys() ? DocKey.DNI_P_ATRAS : DocKey.DNI_ATRAS;
    return key === frontKey || key === backKey;
  }

  onHeaderBack(): void {
    if (this.bioFaceStageActive) {
      this.bioFaceFlow?.resetFlow();
      this.bioFaceStageActive = false;
      this.sesion.setItem(BIO_CUSTOMER_BIOMETRIC_SESSION_KEY, null);
      return;
    }
    if (this.isIdentityStageActive && this.bioDocumentFlow) {
      this.bioDocumentFlow.goBack();
    } else {
      this.back();
    }
  }

  onBioFaceCompleted(_result: BioFaceCaptureResult): void {
    this.bioFaceStageActive = false;
    this.bioIdentityCompleted = true;
    this.bioValidationState = 'succeeded';
    this.proceedAfterBioCapture();
  }

  /** finish_fail de selfie descarta el requestId y vuelve al inicio del alta. */
  onBioFaceFinalError(): void {
    const staleRequestId = this.bioInitResponse?.requestId;
    this.sesion.setItem(BIO_CUSTOMER_BIOMETRIC_SESSION_KEY, null);
    this.bioFaceStageActive = false;
    this.bioIdentityCompleted = false;
    this.bioUploading = false;
    this.bioValidationState = 'idle';
    this.bioInitResponse = undefined;
    if (staleRequestId) {
      this.bioValidationService.clearPresignedCache(staleRequestId);
    }
    this.bioFaceFlow?.resetFlow();
    this.bioDocumentFlow?.restartJourney();
    this.onComplete.emit(1);
  }

  onBioInitCompleted(initResponse: BioProcessInitResponse): void {
    this.sesion.setItem(BIO_CUSTOMER_BIOMETRIC_SESSION_KEY, null);
    this.bioInitResponse = initResponse;
  }

  /** finish_fail de DNI descarta el journey y vuelve al inicio del alta. */
  onBioDocumentJourneyTerminated(): void {
    const staleRequestId = this.bioInitResponse?.requestId;
    this.sesion.setItem(BIO_CUSTOMER_BIOMETRIC_SESSION_KEY, null);
    this.bioInitResponse = undefined;
    this.bioIdentityCompleted = false;
    this.bioFaceStageActive = false;
    this.bioUploading = false;
    this.bioValidationState = 'idle';
    if (staleRequestId) {
      this.bioValidationService.clearPresignedCache(staleRequestId);
    }
    this.bioFaceFlow?.resetFlow();
    this.bioDocumentFlow?.restartJourney();
    this.onComplete.emit(1);
  }

  onBioValidationResult(result: BioDocumentValidationResult): void {
    if (result.errorKind === 'PROCESS_EXPIRED') {
      this.sesion.setItem(BIO_CUSTOMER_BIOMETRIC_SESSION_KEY, null);
      return;
    }
    if (this.bioApplicable && result.requestId && result.requestId === this.bioInitResponse?.requestId && result.customerBiometricId != null) {
      this.sesion.setItem<BioCustomerBiometricSession>(BIO_CUSTOMER_BIOMETRIC_SESSION_KEY, {
        requestId: result.requestId,
        customerBiometricId: result.customerBiometricId,
      });
    }
  }

  onBioIdentityCompleted(result: BioDocumentCaptureResult): void {
    if (this.bioUploading || this.bioFaceStageActive) {
      return;
    }

    const isJuridica = this.usesJuridicaRepresentativeKeys();
    const frontKey = isJuridica ? DocKey.DNI_P_FRENTE : DocKey.DNI_FRENTE;
    const backKey = isJuridica ? DocKey.DNI_P_ATRAS : DocKey.DNI_ATRAS;
    const frontDocId = isJuridica ? DocumentId.DNI_PRESIDENTE_FRENTE : DocumentId.DNI_FRENTE;
    const backDocId = isJuridica ? DocumentId.DNI_PRESIDENTE_DORSO : DocumentId.DNI_DORSO;

    this.bioUploading = true;
    this.bioValidationState = 'validating';
    this.bioDocumentFlow?.reportHostProcessing('Estamos cargando tus fotos...');
    forkJoin({
      front: this.uploadCapturedFile(result.frontFile, frontDocId),
      back: this.uploadCapturedFile(result.backFile, backDocId),
    }).subscribe({
      next: ({ front, back }) => {
        this.documentForm.controls[frontKey]?.setValue([front]);
        this.documentForm.controls[backKey]?.setValue([back]);
        this.bioUploading = false;
        this.bioValidationState = 'uploaded';
        this.bioFaceStageActive = true;
      },
      error: () => {
        this.bioUploading = false;
        this.bioValidationState = 'failed';
        this.bioDocumentFlow?.reportHostUploadFailed(
          'No pudimos cargar tus fotos. Revisá tu conexión e intentá nuevamente.',
        );
      },
    });
  }

  private proceedAfterBioCapture(): void {
    if (this.bioApplicable && this.bioValidationState !== 'succeeded') {
      return;
    }
    if (this.documentForm.valid) {
      this.setQuestionInfo();
      this.formComplete();
    }
  }

  private uploadCapturedFile(file: File, documentId: number): Observable<FileSave> {
    const fileName = this.bucketService.createFilename(file);
    return this.bucketService.getPresignUrlUpload(fileName, file.type).pipe(
      switchMap((url) => from(this.bucketService.uploadToPresignedUrl(url, file))),
      switchMap((response) => {
        if (!response.ok) {
          throw new Error('No se pudo cargar el DNI en el almacenamiento documental.');
        }
        return from(this.readFileAsDataUrl(file));
      }),
      map(
        (src) =>
          ({
            src,
            name: fileName,
            type: file.type,
            id: documentId,
            file,
          } as FileSave),
      ),
    );
  }

  private readFileAsDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }


  onSubmit() {
    console.log('onSubmit');
    if (!this.loading) {
      this.submitted = true;
      if (this.documentForm.valid) {
        this.setQuestionInfo();
        this.formComplete();
      }
    }
  }

  setQuestionInfo() {
    this.filesUpload = [];
    this.files.forEach((file, i) => {
      let fileDoc: FileDto = {
        files: this.documentForm.controls[file.key].value,
      };
      this.filesUpload[i] = fileDoc;
    });

    let upload: UploadScreenInfo = {
      fileDoc: this.filesUpload,
      optionMultilateral: this.optionMultilateral,
      dniValidationRequired: this.dniValidationRequired,
      cantAddDniSh: this.cantDniAdd,
    };
    if (
      !this.infoTax?.attachIIBBDocument?.required &&
      this.infoTax?.attachIIBBDocument?.upload &&
      this.infoTax?.IIBBCondition != Constants.NO_INCRIPTO &&
      this.infoTax?.IIBBCondition != Constants.CONVENIO_MULTILARETAL &&
      !this.infoTax?.infoAfip?.simplifiedMonotributo
    ) {
      if (!this.documentForm.controls[DocKey.CONSTANCIA_IIBB].value) upload.attachIIBBDocument = true;
    }
    this.service.saveFiles(upload);
  }

  formComplete() {
    this.onComplete.emit(6);
  }

  getFilesSesion() {
    if (this.files) {
      let controls: any = {};
      this.files.forEach((element, i) => {
        if (element.required) {
          controls[element.key] = new FormControl(
            this.fileSesion.fileDoc.length >= 1 ? this.fileSesion.fileDoc[i]?.files : '',
            [Validators.required],
          );
        } else {
          controls[element.key] = new FormControl(
            this.fileSesion.fileDoc.length >= 1 ? this.fileSesion.fileDoc[i]?.files : '',
          );
        }
      });

      this.documentForm = new FormGroup(controls);
    }
  }

  ocrValidation() {
    let cuit: string = '';
    if (this.infoTax?.noCuit == false) {
      cuit = this.infoTax?.numIdentification;
    }
    if (this.infoTax?.noCuit) {
      cuit = this.infoTax?.numIdentification;
    }
    let dni = Utils.getDni(cuit);
    let file: FileSave[] = this.documentForm.controls[DocKey.DNI_ATRAS].value;
    if (file?.[0]?.file) {
      let src = file[0].src.replace(/^data:image\/[a-z]+;base64,/, '');
      this.service.validateOcr(src, dni).subscribe(
        (data) => {
          if (data.message == 202) {
            this.ocrValidationFail();
          } else {
            this.ocrValidationCorrect();
          }
        },
        (error) => {
          this.ocrValidationFail();
        },
      );
    }
  }

  ocrValidationCorrect() {
    this.dniValidationRequired = false;
    this.ocrError = false;
  }

  ocrValidationFail() {
    if (this.validateCount >= 1) {
      this.ocrError = false;
    } else {
      console.log('ocr error', this.documentForm.controls[DocKey.DNI_ATRAS].value);
      this.bucketSubscription = this.bucketService
        .deleteFileBucket(this.documentForm.controls[DocKey.DNI_ATRAS].value[0].name)
        .subscribe(() => console.log('El documento se eliminó correctamente'));
      this.documentForm.controls[DocKey.DNI_ATRAS].reset();
      this.ocrError = true;
    }
    this.dniValidationRequired = true;
    this.validateCount++;
  }


  spliceFileAndSesionFile(cant: number) {
    this.files.splice(this.files.length - cant, cant);
    if (this.fileSesion?.optionMultilateral) {
      this.fileSesion.fileDoc.splice(this.fileSesion.fileDoc.length - cant, cant);
    }
  }

  @HostListener('scroll', ['$event'])
  onScroll(e: any) {
    this.shadowScroll.scroll(e);
  }

  addDniSh() {
    this.cantFiles++;
    let newDniFiles: any[] = [];
    let numIntegrantesObligatorios = 2;
    let numIntegrantesAgregados = this.cantDniAdd / 2;
    let fileOne = this.setFileDni(
      'Frente DNI Socio ' + Number(numIntegrantesAgregados + numIntegrantesObligatorios),
      'file 2',
      ['.png', '.jpeg', '.jpg', '.pdf'],
      20,
      true,
      false,
      DocumentId.DNI_INTEGRANTE,
      true,
      DocKey.DNI_O_FRENTE + Number(numIntegrantesAgregados + 1),
      CreateFile.ONE_FILE,
    );
    this.documentForm.addControl(
      DocKey.DNI_O_FRENTE + Number(numIntegrantesAgregados + 1),
      new FormControl(this.fileSesion.fileDoc.length >= 1 ? this.fileSesion.fileDoc[this.files.length]?.files : '', [
        Validators.required,
      ]),
    );
    this.files.splice(this.cantDniAdd + numIntegrantesObligatorios * 2, 0, fileOne);
    let fileTwo = this.setFileDni(
      'Dorso DNI Socio ' + Number(numIntegrantesAgregados + numIntegrantesObligatorios),
      'file 2',
      ['.png', '.jpeg', '.jpg', '.pdf'],
      20,
      true,
      false,
      DocumentId.DNI_INTEGRANTE,
      true,
      DocKey.DNI_O_ATRAS + Number(numIntegrantesAgregados + 1),
      CreateFile.ONE_FILE,
    );
    this.documentForm.addControl(
      DocKey.DNI_O_ATRAS + Number(numIntegrantesAgregados + 1),
      new FormControl(this.fileSesion.fileDoc.length >= 1 ? this.fileSesion.fileDoc[this.files.length]?.files : '', [
        Validators.required,
      ]),
    );
    this.files.splice(this.cantDniAdd + 5, 0, fileTwo);
    newDniFiles.push(fileTwo);
    this.cantDniAdd += +2;
  }

  setFileDni(
    label: string,
    fileId: string,
    extensions: string[],
    size: number,
    isImg: boolean,
    validate: boolean,
    documentId: number,
    required: boolean,
    key: string,
    oneFile?: boolean,
  ) {
    let file = {
      label: label,
      fileId: fileId,
      file: null,
      extensions: extensions,
      size: size,
      isImg: isImg,
      ocrValidation: validate,
      documentId: documentId,
      oneFile: oneFile ? oneFile : false,
      required: required,
      key: key,
    };
    return file;
  }

  calculateButton(index: number) {
    if (this.cantDniAdd == 0 && index == 3) {
      return true;
    } else if (this.cantDniAdd > 0) {
      let position = this.cantDniAdd + 3;
      if (position == index) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
